<template>
  <div
    v-if="hasItems"
    class="panel-mobile-menu panel-scrollbar flex min-h-0 flex-1 flex-col gap-1 py-1"
    dusk="sidebar-menu"
    role="navigation"
    :dir="isRTL ? 'rtl' : 'ltr'"
  >
    <component
      :key="item.key"
      :is="item.component"
      v-for="item in mainMenu"
      :item="item"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',

  computed: {
    ...mapGetters(['mainMenu']),

    isRTL() {
      return Nova.config('rtlEnabled')
    },

    hasItems() {
      return this.mainMenu.length > 0
    },
  },
}
</script>
